export const TOKEN = `token_${process.env.VUE_APP_ID}`;

const makeToken = (Storage, Auth) => {
  const token = () => Storage.getObject(TOKEN);
  const setToken = (value) => {
    if (value) {
      Storage.setObject(TOKEN, value);
    } else {
      Storage.remove(TOKEN);
    }
  };

  const accessToken = async (login, password) => {
    const response = await Auth.accessToken(login, password);
    if (response.status === 200) {
      setToken(response.data);
    }
    return response;
  };

  const refreshToken = async () => {
    const tokenRefresh = token();
    const response = await Auth.refreshToken(tokenRefresh.refresh_token);
    if (response.status === 200) {
      setToken(response.data);
    }
    return response;
  };

  const revokeToken = async () => {
    const response = await Auth.logout();
    if (response.status === 200) {
      setToken(null);
    }
    return response;
  };

  const getTokenAuthorization = () => {
    const tokenAccess = token();
    if (tokenAccess !== null && tokenAccess !== undefined) {
      return `Bearer ${tokenAccess.access_token}`;
    }
    return null;
  };

  return {
    token,
    setToken,
    accessToken,
    refreshToken,
    revokeToken,
    getTokenAuthorization,
  };
};

export default makeToken;
